export const initialState = {
    selecionadas: [],
    totalSelecionadas: undefined,
    valorParcela: undefined,
    maxParcelas: undefined,
    taxaJuros: undefined,
    forma: undefined,
    numParcelas: undefined,
    entrada: undefined,
    boletos: undefined,
    confirmar: false,
    finalizar: false,
};

const calcValorEntrada = (valor, perc) => {
    return (perc / 100) * valor
}

const calcTaxaAdm = (valor, numParcelas, juros) => {
    const taxaPorParcela = Math.pow((1 + (juros / 100)), numParcelas)
    return valor * taxaPorParcela
};

const calcValorParcelas = ({ newTotal, entrada, maxParcelas, juros }) => {
    let formaPgto = {}
    let totalFormaPgto = {}

    for (let parcelas = 1; parcelas <= maxParcelas; parcelas++) {
        const newValorParcela = calcTaxaAdm((newTotal - entrada) / parcelas, parcelas, juros);
        formaPgto[`${parcelas}`] = newValorParcela
        totalFormaPgto[`${parcelas}`] = newValorParcela * parcelas
    }

    return { formaPgto, totalFormaPgto }
}

const clickFatura = (state, results, selectedItems) => {
    const maxParcelas = state.maxParcelas || 1;
    const juros = state.taxaJuros || 0;
    let entrada = 0
    let boletoPagamentoProps = {}

    const newFaturasSelecionadas = results?.faturas
        .filter(item => selectedItems.includes(`${item.fatura.trim()}${item.id_parcela.trim()}`))

    const newTotal = newFaturasSelecionadas.reduce((acc, curr) => acc + curr.saldo_principal_devido_com_juros, 0);

    if (state.forma === 'boleto') {
        const percInicialEntrada = results?.paramsPagamento?.boleto?.entrada
        entrada = calcValorEntrada(newTotal, state?.entrada?.perc || percInicialEntrada);

        boletoPagamentoProps = {
            entrada: {
                valor: entrada,
                perc: state.entrada?.perc || percInicialEntrada
            },
        }
    }

    const { formaPgto, totalFormaPgto } = calcValorParcelas({ entrada, juros, maxParcelas, newTotal })

    const f = {
        selecionadas: newFaturasSelecionadas,
        totalSelecionadas: { formaPgto: totalFormaPgto, semTaxa: newTotal },
        valorParcela: { formaPgto, semTaxa: newTotal },
        entrada: undefined,
        ...boletoPagamentoProps
    }

    return { ...state, ...f }
}

const clickFormaPagamento = (state, results, formaPagamento, boletos) => {
    formaPagamento = formaPagamento || state.forma
    boletos = boletos || state.boletos

    const percInicialEntrada = results?.paramsPagamento?.boleto?.entrada
    let newTotal = state.totalSelecionadas.semTaxa
    let totalSelecionadasSemTaxa = state.totalSelecionadas.semTaxa
    let maxParcelas;
    let juros;
    let entrada = 0
    let boletoPagamentoProps = {}

    if (formaPagamento === 'pix') {
        maxParcelas = 1
        juros = results?.paramsPagamento?.pix?.taxa
    }
    else if (formaPagamento === 'cartao') {
        maxParcelas = results?.paramsPagamento?.cartao?.parcela
        juros = results?.paramsPagamento?.cartao?.taxa
    }
    else if (formaPagamento === 'boleto') {
        if (boletos === 'semanal') maxParcelas = results?.paramsPagamento?.boleto?.intervalo.semanal
        else if (boletos === 'quinzenal') maxParcelas = results?.paramsPagamento?.boleto?.intervalo.quinzenal
        else if (boletos === 'mensal') maxParcelas = results?.paramsPagamento?.boleto?.intervalo.mensal

        juros = results?.paramsPagamento?.boleto?.taxa
        totalSelecionadasSemTaxa = results.divida.internaComJuros
        newTotal = results.divida.internaComJuros
        entrada = calcValorEntrada(newTotal, state?.entrada?.perc || percInicialEntrada);

        boletoPagamentoProps = {
            boletos,
            entrada: {
                valor: entrada,
                perc: state.entrada?.perc || percInicialEntrada
            },
            selecionadas: results.faturas
        }
    }
    const { formaPgto, totalFormaPgto } = calcValorParcelas({ entrada, juros, maxParcelas, newTotal })

    const f = {
        totalSelecionadas: { formaPgto: totalFormaPgto, semTaxa: totalSelecionadasSemTaxa },
        valorParcela: { formaPgto, semTaxa: totalSelecionadasSemTaxa },
        forma: formaPagamento,
        boletos: undefined,
        numParcelas: undefined,
        maxParcelas,
        taxaJuros: juros,
        entrada: undefined,
        ...boletoPagamentoProps
    }
    return { ...state, ...f }
}

const clickParcelas = (state, numParcelas) => ({ ...state, numParcelas: parseInt(numParcelas) })

const clickEntrada = (state, percentage) => {
    const p = parseInt(percentage)
    const newEntrada = calcValorEntrada(state.totalSelecionadas?.semTaxa, p)

    const pgto = {
        entrada: { valor: newEntrada, perc: p },
        boletos: undefined
    }
    return { ...state, ...pgto }
}

export function negociacaoReducer(state, action) {
    switch (action.type) {
        case 'setFaturas':
            return { ...state, ...action.payload };
        case 'setModals':
            return { ...state, ...action.payload };
        case 'clickFatura':
            return clickFatura(state, action.payload.results, action.payload.selectedItems);
        case 'clickFormaPagamento':
            return clickFormaPagamento(state, action.payload.results, action.payload.formaPagamento, action.payload.boletos);
        case 'clickParcelas':
            return clickParcelas(state, action.payload.numParcelas);
        case 'clickEntrada':
            return clickEntrada(state, action.payload.percentage);
        default:
            return state;
    }
}
